import {
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
  IonContent,
} from '@ionic/react'

interface HelpModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  content: string
}

export const HelpModal = ({ isOpen, onClose, title, content }: HelpModalProps) => {
  return (
    <IonModal isOpen={isOpen} onDidDismiss={onClose}>
      <IonHeader>
        <IonToolbar>
          <IonTitle className="ml-4">{title}</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={onClose}>Cerrar</IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <div
          className="help-content text-sm prose prose-sm max-w-none [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-3 [&_li]:leading-relaxed [&_ul_ul]:list-disc [&_ul_ul]:pl-5 [&_ul_ul]:mt-2"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </IonContent>
    </IonModal>
  )
}
